
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class CustomersGrid extends Serenity.EntityGrid<CustomersRow, any> {
        protected getColumnsKey() { return CustomersColumns.columnsKey; }
        protected getDialogType() { return CustomersDialog; }
        protected getIdProperty() { return CustomersRow.idProperty; }
        protected getInsertPermission() { return CustomersRow.insertPermission; }
        protected getLocalTextPrefix() { return CustomersRow.localTextPrefix; }
        protected getService() { return CustomersService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;
        private FranchiseeId;
        private InvoiceId;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);

            buttons.push({
                title: 'Send Email',
                cssClass: 'print-button',
                separator: true,
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select order first");
                        return;
                    }
                    else {
                        new Users.CustomerEmailDialog(this, true, rowKeys.toString()).dialogOpen();
                    }
                }
            });

            buttons.push({
                title: 'Send SMS',
                cssClass: 'print-button',
                separator: true,
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select order first");
                        return;
                    }
                    else {
                        new Users.CustomersSMSDialog(this, true, rowKeys.toString()).dialogOpen();
                    }
                }
            });
            buttons.push({
                title: 'Import From Excel',
                cssClass: 'export-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new CustomersExcelImportDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });
            buttons.push({
                title: 'Download Customer Sample',
                cssClass: 'export-xlsx-button',
                separator: true,
                onClick: () => {
                    /*  debugger;*/
                    var url = "~/Users/Customers/CustomerImportSample";
                    /*var url = "~/Uploads/ProductsImportSample.xlsx";*/

                    Q.postToService({ url: Q.resolveUrl(url), request: '', target: '_blank' });
                }
            });

            buttons.push({
                title: 'Assign to Enquiry',
                cssClass: 'edit-button',
                onClick: () => {
                    var SelectedKeys = this.rowSelection.getSelectedKeys();
                    if (SelectedKeys.length == 0) {
                        Q.alert("Please select atleast one Customer!");
                        return;
                    }
                    debugger;
                    new RioERP.Enquiry.CustomerEnquiryDialog(this, true, SelectedKeys).loadNewAndOpenDialog();
                },
                separator: true
            });

            return buttons;
        }
    }
}